import { render, staticRenderFns } from "./ConversationFacts.vue?vue&type=template&id=7497fc2d&scoped=true"
import script from "./ConversationFacts.vue?vue&type=script&lang=js"
export * from "./ConversationFacts.vue?vue&type=script&lang=js"
import style0 from "./ConversationFacts.vue?vue&type=style&index=0&id=7497fc2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7497fc2d",
  null
  
)

export default component.exports